import { css } from 'styled-components';
import { StyledPanel } from '../../../../components/InfoBanner/styles';
import { colors, themeSpecificColors } from '../../colors';

export default css`
  ${StyledPanel} {
    background-color: ${colors.neutral08};
    box-shadow: none;
    border: solid 1px ${themeSpecificColors.core01_20};
  }
`;
